module.exports = __webpack_public_path__ + "img/download-on-google-play-en.5d7ff6c7.svg";